import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import SectionHeading from '../../Common/SectionHeading';

const ChooseDI = ({title=null}) => {
  return (
    <section className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-8 my-4">
        <div className="grid grid-cols-12 gap-4">
            <div className="lg:col-span-8 col-span-12">
                <div className='col-span-12'>
                    {(title) &&
                        <SectionHeading title={title}  customClass="text-left"/>
                    }
                </div>
                <p className="text-base">
                    DelveInsight’s analyst team is well-versed with the industry standards and norms and is an expert in competitive intelligence tracking. We have been actively engaged in CI work and are equipped with the right research and analysis tools. Our team’s in-depth knowledge of the pharmaceutical and life sciences industry helps us create valuable, simplified, and in-depth reports for your company’s leadership to make informed decisions.
                </p>
                <Link href={process.env.APP_URL+"/request-for-proposal"}>
                    <button className="mt-4 py-2 px-4 btn">Request for Proposal</button>
                </Link>
            </div>
            <div className="lg:col-span-4 col-span-12">
                <Image 
                    priority={false} 
                    width={2000} 
                    height={2000} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/why-choose-delveInsight.png'}
                    className="hidden lg:block" 
                    alt="Why Choose DelveInsight" 
                />
            </div>
        </div>
    </section>
  );
};

export default ChooseDI;